/**
 * POST `auth/change-password` — смена пароля команды, в том числе
 * обязательная смена временного при первом входе. Новый — от 8 знаков.
 */

import {apiEnabled, http} from '@services/utils';

export type ChangePasswordInput = {currentPassword: string; newPassword: string};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const changePassword = async (input: ChangePasswordInput): Promise<void> => {
  if (!apiEnabled) {
    await sleep(400);
    return;
  }
  await http('auth/change-password', {method: 'POST', body: input, skipCaseConversion: true});
};
